import type { SearchStatus } from '@features/partnerships/context/partnerships-wizard-types';

const SYNONYM_MAP: Record<string, SearchStatus> = {
  searching: 'running',
  queued: 'running',
  in_progress: 'running',
  done: 'completed',
  success: 'completed',
  error: 'failed',
};

const CANONICAL: Set<string> = new Set(['pending', 'running', 'completed', 'failed']);

/**
 * Normalizes a raw status value from the backend into a canonical SearchStatus.
 *
 * Known synonyms are mapped to their canonical form; unrecognized values
 * default to 'running' (non-terminal) so polling continues rather than
 * entering a stuck state.
 */
export function normalizeSearchStatus(raw: unknown): SearchStatus {
  const s = typeof raw === 'string' ? raw.toLowerCase() : '';
  if (CANONICAL.has(s)) return s as SearchStatus;
  if (s in SYNONYM_MAP) return SYNONYM_MAP[s];
  return 'running';
}

/**
 * Returns true if the status indicates the search has reached a final state.
 */
export function isTerminalStatus(s: SearchStatus): boolean {
  return s === 'completed' || s === 'failed';
}

/**
 * Maximum number of poll attempts before the frontend declares a timeout.
 * At 3 s per poll, 60 attempts = 3 minutes.
 */
export const MAX_POLL_ATTEMPTS = 60;
